import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject, Signal } from '@angular/core';
import { MpnSubscription, MpnSubscriptionsQueryParams } from '@models/csp/mpn-subscription.model';
import { signalStore, withMethods, withState } from '@ngrx/signals';
import { getAllWithParams, StateDictionary } from '../../helpers';
import { MpnSubscriptionsService } from './mpn-subscriptions.service';

type MpnSubscriptionsState = {
  mpnSubscriptions: MpnSubscription[];
  mpnSubscriptionsLoading: boolean;
};

const initialState: MpnSubscriptionsState = {
  mpnSubscriptions: [],
  mpnSubscriptionsLoading: false,
};

const mpnSubscriptionsDictionary: StateDictionary<MpnSubscription> = {
  entityList: 'mpnSubscriptions',
  listLoading: 'mpnSubscriptionsLoading',
  createLoading: '',
  selectedEntity: '',
  selectedEntityLoading: '',
  entityId: 'subscriptionId',
};

export const MpnSubscriptionsStore = signalStore(
  withState(initialState),
  withDevtools('csp-subscriptions-store'),
  withMethods((store, mpnSubscriptionsService = inject(MpnSubscriptionsService)) => {
    return {
      getMpnSubscriptions: getAllWithParams<MpnSubscription, MpnSubscriptionsQueryParams>({
        store,
        service: mpnSubscriptionsService,
        dictionary: mpnSubscriptionsDictionary,
      }),
    };
  }),
);

export interface MpnSubscriptionsStoreType {
  readonly mpnSubscriptions: Signal<MpnSubscription[]>;
  readonly mpnSubscriptionsLoading: Signal<boolean>;
  readonly getMpnSubscriptions: (params: MpnSubscriptionsQueryParams) => void;
}
